/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Changes_Item_1Inputs */

const es_privacy_policy_changes_item_1 = /** @type {(inputs: Privacy_Policy_Changes_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificacion por correo electronico a la direccion de su cuenta`)
};

const en_privacy_policy_changes_item_1 = /** @type {(inputs: Privacy_Policy_Changes_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email notification to your account address`)
};

/**
* | output |
* | --- |
* | "Email notification to your account address" |
*
* @param {Privacy_Policy_Changes_Item_1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_changes_item_1 = /** @type {((inputs?: Privacy_Policy_Changes_Item_1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Changes_Item_1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_changes_item_1(inputs)
	return en_privacy_policy_changes_item_1(inputs)
});
export { privacy_policy_changes_item_1 as "privacy_policy.changes.item_1" }